import { createContext, useContext } from 'react';

interface FlyoutContextValue {
    /**
     * Verdadeiro para tudo que está sendo renderizado DENTRO de um painel
     * flutuante.
     *
     * Lá dentro `useSidebarState()` continua dizendo "recolhida", mas há
     * largura para texto — e é isso que dois lugares precisam saber: o grupo
     * aninhado vira linha com seta (e abre o painel dele AO LADO, não por
     * baixo) e o `MenuItemLink` cala o tooltip, porque o rótulo já está à vista.
     */
    insideFlyout: boolean;
    /** Fecha este painel e, em cascata, todos os que o abriram. */
    close: () => void;
}

const SubMenuFlyoutContext = createContext<FlyoutContextValue>({
    insideFlyout: false,
    close: () => undefined,
});

export const SubMenuFlyoutProvider = SubMenuFlyoutContext.Provider;

export const useFlyoutContext = () => useContext(SubMenuFlyoutContext);

export const useIsInsideFlyout = () => useContext(SubMenuFlyoutContext).insideFlyout;
